import type { AnimalSummary } from '@/api/hooks';
import { RowActionsDropdown, RowActionsMenuItem } from '@/components/ui/RowActionsDropdown';
import { useT } from '@/lib/i18n';
import { ArrowLeftRight, ClipboardList, Dna, FilePenLine, Layers, Trash2 } from 'lucide-react';

type AnimalRowActionsMenuProps = {
  animal: AnimalSummary;
  onCreateEvent: (animal: AnimalSummary) => void;
  onCreateMovement: (animal: AnimalSummary) => void;
  onCreateReproduction: (animal: AnimalSummary) => void;
  onAssignLot: (animal: AnimalSummary) => void;
  onEditFicha: (animal: AnimalSummary) => void;
  onDelete?: (animal: AnimalSummary) => void;
  canDelete?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export function AnimalRowActionsMenu({
  animal,
  onCreateEvent,
  onCreateMovement,
  onCreateReproduction,
  onAssignLot,
  onEditFicha,
  onDelete,
  canDelete = false,
  onOpenChange,
}: AnimalRowActionsMenuProps) {
  const t = useT();
  const lotActionLabel = animal.lot_id ? 'Mover para lote' : 'Adicionar ao lote';
  const operational = !animal.is_archive;

  return (
    <RowActionsDropdown
      label={`Ações para animal ${animal.internal_number}`}
      trigger="labeled"
      triggerText={t('common.options')}
      onOpenChange={onOpenChange}
    >
      {operational && (
        <>
          <RowActionsMenuItem
            icon={Layers}
            label={lotActionLabel}
            onClick={() => onAssignLot(animal)}
          />
          <RowActionsMenuItem
            icon={ClipboardList}
            label="Criar Evento"
            onClick={() => onCreateEvent(animal)}
          />
          <RowActionsMenuItem
            icon={ArrowLeftRight}
            label="Criar Movimentação"
            onClick={() => onCreateMovement(animal)}
          />
          <RowActionsMenuItem
            icon={Dna}
            label="Criar Reprodução"
            onClick={() => onCreateReproduction(animal)}
          />
          <div className="my-1 border-t border-manejai-sand/60" />
        </>
      )}
      <RowActionsMenuItem
        icon={FilePenLine}
        label="Editar ficha do Animal"
        onClick={() => onEditFicha(animal)}
      />

      {canDelete && onDelete && (
        <>
          <div className="my-1 border-t border-manejai-sand/60" />
          <RowActionsMenuItem
            icon={Trash2}
            label="Excluir Animal"
            onClick={() => onDelete(animal)}
            danger
          />
        </>
      )}
    </RowActionsDropdown>
  );
}
